<template>

    <b-row class="input-add-use mb-3">
      <b-col sm="2">
        <label for="input-3">Регион поиска<span v-if="isCustomCountry"> (<b-link href="https://www.nationsonline.org/oneworld/country_code_list.htm" target="_blank">www.nationsonline.org</b-link>)</span>:
        </label>
      </b-col>
      <b-col sm="10" v-if="!isCustomCountry">
        <b-overlay :show="showOverlay > 0" class="overlay" rounded="lg">
          <b-form-select
              id="input-3"
              v-model="region"
              :options="countryOptions"
              size="sm"
              v-on:change="countrySelect()"
          ></b-form-select>
        </b-overlay>
      </b-col>
      <!--                        custom-->
      <b-col sm="8"
             v-if="isCustomCountry"
      >
        <b-form-input id="input-3" size="sm" v-model="region" autocomplete="off">
        </b-form-input>
      </b-col>
      <b-col sm="2"
             v-if="isCustomCountry"
      ><b-button
          variant="primary"
          v-on:click="isCustomCountry = false; region = 'all'"
          size="sm"
          class="toggle-button"
      >Выбрать из списка</b-button>
      </b-col>
    </b-row>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('countrySelectComponents');

export default {
  name: "CountrySelect",
  props: {
    valueChange: Function,
  },
  data() {
    return {
      countryOptions: [
        {value: 'all', text: "Все страны"},
        {value: '', text: "Указать другую страну"},
      ],
      isCustomCountry: false,
      showOverlay: 0,
      region: 'all',
    }
  },
  methods: {
    ...mapActions(['GET_REGIONS']),
    countrySelect() {
      this.isCustomCountry = (this.region === '')
    },
    prepareRegions(regions) {
      for (let key in regions) {
        this.countryOptions.push({value: key, text: regions[key]})
      }
    }
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {
    region(newVal) {
      this.valueChange(newVal)
    }
  },
  mounted() {
    this.GET_REGIONS({th: this})
    this.region = 'all'
  },
}
</script>

<style scoped>

</style>